// Choose a work center once; the tablet remembers it (T1).
import { useStations } from '../../api/queries';
import { EmptyState, ErrorPanel, Loading, PageHeader } from '../../design/components';

export function StationPicker({ onPick }: { onPick: (station: string) => void }) {
    const stations = useStations();
    if (stations.isPending) return <Loading what="stations" />;
    if (stations.isError) return <ErrorPanel error={stations.error} title="The stations couldn’t be loaded." />;
    const enabled = stations.data.filter((station) => station.enabled);
    return (
        <section className="sf-stack" aria-labelledby="pick-station">
            <PageHeader
                id="pick-station"
                title="Which station is this tablet at?"
                description="Pick it once. This tablet remembers it."
            />
            {enabled.length === 0 ? (
                <EmptyState>
                    No stations yet. A kit delivered to a work center adds its station, or the lead can set them up.
                </EmptyState>
            ) : (
                <ul className="sf-grid" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {enabled.map((station) => (
                        <li key={station.workCenter}>
                            <button
                                type="button"
                                className="sf-card sf-tile"
                                style={{ minHeight: 120 }}
                                onClick={() => {
                                    onPick(station.workCenter);
                                }}
                            >
                                <span>{station.workCenter}</span>
                                <span className="sf-muted text-sm">
                                    {station.ready} ready · {station.inProgress} in progress · {station.onHold} on hold
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
}
